// @flow

import {toast} from "react-toastify"

import type {
  ProductsByCategory,
  Action,
  ThunkAction,
  Dispatch,
  ProductOrSet,
  ProductMedia,
} from "../types"
import {get} from "../client"
// import i18n from '../i18n'
import i18n from "i18next"

export const fetchProducts = (babyToken: string): ThunkAction => {
  return (dispatch: Dispatch) => {
    return get(`/babies/${babyToken}/products`).then(response => {
      if (response.data) {
        dispatch(setProducts(response.data))
      } else {
        toast.error(i18n.t("toast.products.fetch.error"))
      }
    })
  }
}

export const setProducts = (
  products: $ReadOnlyArray<ProductsByCategory>
): Action => ({
  type: "SET_PRODUCTS",
  products,
})

export const toggleProduct = (product: ProductOrSet): Action => ({
  type: "TOGGLE_PRODUCT",
  product,
})

export const resetToggledProducts = (): Action => ({
  type: "RESET_TOGGLE_PRODUCT",
})

export const toggleRevealedProduct = (product: ProductOrSet): Action => ({
  type: "TOGGLE_REVEALED_PRODUCT",
  product,
})

export const getProductMedia = (id: number): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(clearMedia()) // clear previous
    return get(`/products/${id}/media`).then(response => {
      if (response.data) {
        dispatch(setMedia(response.data))
      } else {
        toast.error(i18n.t("toast.media.fetch.error"))
      }
    })
  }
}

export const getProductSetMedia = (id: number): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch(clearMedia()) // clear previous
    return get(`/products/${id}/media?isSet=true`).then(response => {
      if (response.data) {
        dispatch(setMedia(response.data))
      } else {
        toast.error(i18n.t("toast.media.fetch.error"))
      }
    })
  }
}

export const setMedia = (media: $ReadOnlyArray<ProductMedia>): Action => ({
  type: "SET_MEDIA",
  media,
})

export const clearMedia = (): Action => ({type: "CLEAR_MEDIA"})
